import { useState } from 'react';
import { getFirestore, collection, addDoc } from 'firebase/firestore';
import moment from 'moment';

const STORAGE_KEY = 'whitelist_request';

export const useWhitelistAccess = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');
    const [storedEmail, setStoredEmail] = useState(() => {
        // Load from localStorage on initial render
        if (typeof window !== 'undefined') {
            const saved = localStorage.getItem(STORAGE_KEY);
            return saved ? JSON.parse(saved) : null;
        }
        return null;
    });

    // In useWhitelistAccess.js
    const requestAccess = async (email) => {
        if (!email) {
            setError('Please enter a valid email address');
            return false;
        }

        setIsLoading(true);
        setError('');

        try {
            const db = getFirestore();
            await addDoc(collection(db, 'whiteListAccessEmail'), {
                email: email.toLowerCase(),
                requestedAt: moment().unix(),
                status: 'pending'
            });

            // Save to localStorage
            const requestData = {
                email: email.toLowerCase(),
                timestamp: moment().unix()
            };
            localStorage.setItem(STORAGE_KEY, JSON.stringify(requestData));
            setStoredEmail(requestData);

            return true;
        } catch (e) {
            console.error('Error adding document: ', e);
            setError('Failed to submit request. Please try again later.');
            return false;
        } finally {
            setIsLoading(false);
        }
    };
    
    const clearStoredRequest = () => {
        localStorage.removeItem(STORAGE_KEY);
        setStoredEmail(null);
    };

    return {
        isLoading,
        error,
        storedEmail,
        requestAccess,
        clearStoredRequest
    };
};

export default useWhitelistAccess;
